// extracted by mini-css-extract-plugin
module.exports = {"header":"FiltersHeader_header__2uTXT","close":"FiltersHeader_close__8ts1E","title":"FiltersHeader_title__V1IrX","reset":"FiltersHeader_reset__1-jFG"};